import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import ImportOutsourceRow from './ImportOutsourceRow';
import { PsTable } from '../../shared/components/table/PsTable';

export default class ImportOutsourceTable extends React.Component {

    renderHead() {
        return (
            <tr>
                <th width="10%">{I18nUtils.tr('TR_CODIGO')}</th>
                <th>{I18nUtils.tr('TR_RAZON_SOCIAL')}</th>
                <th>{I18nUtils.tr('TR_NIF')}</th>
            </tr>
        );
    }

    render() {
        if ( this.props.error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.error}</h3>
                </section>
            );
        }
        if ( !this.props.data || this.props.data.length === 0 ) {
            return null;
        }
        return (
            <PsTable headings={this.renderHead()}>
                {
                    this.props.data.map((outsource, i) =>
                        <ImportOutsourceRow key={i} outsource={outsource} />,
                    )
                }
            </PsTable>
        );
    }

}

ImportOutsourceTable.propTypes = {
    data: PropTypes.any.isRequired,
    error: PropTypes.string,
};

ImportOutsourceTable.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/outsource/components/ImportOutsourceTable.jsx